import Analytics from './analytics';

class ExpandAndCollapse {
    constructor() {
        this.addEventListeners();
    }

    addEventListeners() {        
        var self = this;
        var expandHeaders = document.querySelectorAll('.expand-header');
        expandHeaders.forEach(function (link) {
            link.addEventListener('click',
                function (e) {
                    e.preventDefault();

                    var id = this.getAttribute('aria-controls');
                    var toggleEl = document.querySelector('#' + id);

                    if (this.getAttribute('aria-expanded') == 'false') {
                        this.setAttribute('aria-expanded', 'true');
                        toggleEl.setAttribute('aria-hidden', 'false');
                        this.parentElement.classList.add('expanded');
                        this.innerHTML = `<svg class="icon icon-minus"><use xlink:href="/icons/sprite.svg#minus"/></svg>` + this.text;
                        self.resetAllExpanded(id);
                        Analytics.expandFaq(this.textContent);

                    } else {
                        this.setAttribute('aria-expanded', 'false');
                        toggleEl.setAttribute('aria-hidden', 'true');
                        this.parentElement.classList.remove('expanded');
                        this.innerHTML = `<svg class="icon icon-plus"><use xlink:href="/icons/sprite.svg#plus"/></svg>` + this.text;
                    }
                });
        });
    }

    resetAllExpanded(currentElId) {
        var expandHeaders = document.querySelectorAll('.expand-header');
        expandHeaders.forEach(function (item) {
            var id = item.getAttribute('aria-controls');
            if (id == currentElId) {
                return;
            }
            if (item.getAttribute('aria-expanded') == 'true') {
                var toggleEl = document.querySelector('#' + id);
                item.setAttribute('aria-expanded', 'false');
                toggleEl.setAttribute('aria-hidden', 'true');
                item.parentElement.classList.remove('expanded');
                item.innerHTML = `<svg class="icon icon-plus"><use xlink:href="/icons/sprite.svg#plus"/></svg>` + item.text;
            }
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new ExpandAndCollapse();
});